import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toastStyles = `
  .mandoobee-toast {
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }
  
  .mandoobee-toast-body {
    padding: 0;
  }
  
  .Toastify__toast--default {
    background: #ffffff;
    color: #333333;
    padding: 0;
  }
  
  .Toastify__progress-bar {
    background: linear-gradient(90deg, #007bff, #0056b3);
    height: 4px;
  }
  
  .Toastify__close-button {
    color: #666;
    opacity: 0.8;
  }
  
  .Toastify__close-button:hover {
    opacity: 1;
  }

  .toast-action-btn {
    background: #007bff;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    min-width: 80px;
  }
  
  .toast-action-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  }
  
  .toast-action-btn.success {
    background: #28a745;
  }
  
  .toast-action-btn.success:hover {
    box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
  }
  
  .toast-action-btn.danger {
    background: #dc3545;
  }
  
  .toast-action-btn.danger:hover {
    box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
  }
`;

const ToastProvider = ({ children, delay = 1000 }) => {
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.innerText = toastStyles;
    document.head.appendChild(styleSheet);

    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowToast(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <>
      {children}
      {showToast && (
        <ToastContainer
          position="top-center"
          autoClose={8000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          limit={3}
          className="mandoobee-toast-container hidden lg:block"
          toastClassName="mandoobee-toast"
          bodyClassName="mandoobee-toast-body"
          style={{
            zIndex: 9999,
            marginTop: "60px",
          }}
        />
      )}
    </>
  );
};

export default ToastProvider;